var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTagSolid = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_136",
    "data-name": "Subtra\\xE7\\xE3o 136",
    d: "M7.915,16a1.351,1.351,0,0,1-.959-.4L.4,9.073a1.348,1.348,0,0,1,0-1.911L6.733.909a2.9,2.9,0,0,1,2.26-.9L14.709,0a1.251,1.251,0,0,1,.927.4A1.4,1.4,0,0,1,16,1.359v5.4a3.6,3.6,0,0,1-.678,2.477L8.874,15.6A1.351,1.351,0,0,1,7.915,16ZM12.75,2A1.25,1.25,0,1,0,14,3.25,1.249,1.249,0,0,0,12.75,2Z",
    transform: "translate(-0.001)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTagSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tag-solid.f2c14252.svg";
export { ForwardRef as ReactComponent };